
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {get,post} from '../api'
export default {
components: {
Flexbox,
FlexboxItem,
Swiper,
SwiperItem,
XButton,
Group,
XInput,
XTextarea,
XHeader,
Toast
},
mounted(){
if(this.GLOBAL.currentUser==undefined){
this.$router.push({ path: '/' });
}
let tag = this.$route.query.tag;
let id = this.$route.query.id;
if(tag=='E'){
this.isAdd=false;
this.ruleDetail=this.GLOBAL.currentObjs[id];
console.log(this.ruleDetail);
}
else{
this.isAdd=true;
}
},
methods: {
Save(){
if(this.isAdd==true){
this.ruleDetail.Publisher=this.GLOBAL.currentUser.UserGuid;
post('/ruleinfo/add', this.ruleDetail).then(response => {

if(response.code==1){
this.showSuccess=true;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
}
else if(this.isAdd==false){
post('/ruleinfo/update', this.ruleDetail).then(response => {

if(response.code==1){
this.SuccessInfo='通告修改成功!';
this.showSuccess=true;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
}
},
Cancel(){
this.$router.push({ path: '/RuleInfo' });
}
},
data () {
return {
ruleDetail:{
Title:'',
Content:'',
PublishDate:dateFormat(new Date(), 'YYYY年MM月DD日 HH时mm分')
},
showSuccess:false,
showWarn:false,
showError:false,
SuccessInfo:'通告新增成功!',
WarnInfo:'',
ErrorInfo:'系统异常,联系管理员!',
isAdd:false
}
}
}



// WEBPACK FOOTER //
// ./src/components/ManagerModules/RuleDetail.vue